// import { useState } from "react";
import { useEffect, useState } from "react";
import "../CSS/Login.css";
import api from "../api";

export default function Login({ setIsLoggedIn }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [finYears, setFinYears] = useState([]);
  const [finYearCode, setFinYearCode] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState("");

  
  useEffect(() => {
  loadFinancialYears();
}, []);
const loadFinancialYears = async () => {
  try {
    const res = await api.get("/dropdown?mode=FY");
    setFinYears(res.data);
  } catch (error) {
    console.log(error);
  }
};
  const handleLogin = async () => {
    if (!username.trim() || !password.trim()) {
      setError("Please enter both username and password.");
      return;
    }

    try {
      const res = await api.post("/login", {
        username: username,
        password: password,
        finYearCode: finYearCode
      });

      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("token", res.data.accessToken);
      localStorage.setItem("sessionToken", res.data.sessionToken);
      localStorage.setItem("username", username); // Store username for display
      localStorage.setItem("loginTime", Date.now());

      setIsLoggedIn(true);
       window.location.reload(); //adding for concurrent login
    } catch (err) {
      setError("Invalid username or password");
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">

        {/* ── Company Header ── */}
        <div className="login-company">
          <div className="login-logo-icon">🚚</div>
          <div className="login-company-text">
            <div className="login-company-name">SAAMI TRADESTAR</div>
            <div className="login-company-sub">Logistics Ltd</div>
          </div>
        </div>

        {/* ── ILMS Band ── */}
        <div className="login-ilms-band">
          <span className="login-ilms-name">ILMS</span>
          <span className="login-ilms-full">Innovative Logistics Management System</span>
        </div>

        {/* ── Welcome Heading ── */}
        <div className="login-welcome">
          <div className="login-welcome-title">
            Welcome <span>Back</span>
          </div>
          <div className="login-welcome-sub">
            Sign in to your account to continue
          </div>
        </div>

        {/* ── Form ── */}
        <div className="login-form">

          {/* Username */}
          <div className="login-field">
            <label className="login-label">Username</label>
            <div className={`login-input-wrap${error && !username.trim() ? " error" : ""}`}>
              <span className="login-input-icon">👤</span>
              <input
                className="login-input"
                type="text"
                placeholder="Enter your username"
                value={username}
                onChange={e => { setUsername(e.target.value); setError(""); }}
                onKeyDown={e => e.key === "Enter" && handleLogin()}
                autoComplete="username"
              />
            </div>
          </div>

          {/* Password */}
          <div className="login-field">
            <label className="login-label">Password</label>
            <div className={`login-input-wrap${error && !password.trim() ? " error" : ""}`}>
              <span className="login-input-icon">🔒</span>
              <input
                className="login-input"
                type={showPass ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={e => { setPassword(e.target.value); setError(""); }}
                onKeyDown={e => e.key === "Enter" && handleLogin()}
                autoComplete="current-password"
              />
              <span
                className="login-input-icon"
                style={{ cursor: "pointer", color: "var(--muted)", userSelect: "none" }}
                onClick={() => setShowPass(v => !v)}
                title={showPass ? "Hide password" : "Show password"}
              >
                {showPass ? "🙈" : "👁️"}
              </span>
            </div>
          </div>
           
          <div className="login-field">
            <label className="login-label">Financial Year</label>
            <div className="login-input-wrap">
              <span className="login-input-icon">📅</span>
              <select
                className="login-input"
                style={{ cursor: "pointer", background: "transparent" }}
                value={finYearCode}
                onChange={(e) => setFinYearCode(e.target.value)}
              >
                <option value="">Select Financial Year</option>
                {finYears.map((item, index) => (
                  <option key={index} value={item.FinYear_code}>
                    {item.FinancialYearPeriod}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Error message */}
          {error && <div className="login-error-msg">⚠️ {error}</div>}

          {/* Forgot password */}
          <div className="login-forgot">
            <a href="#">Forgot password?</a>
          </div>

          {/* Login Button */}
          <button className="login-btn" onClick={handleLogin}>
            🔐 &nbsp;Login
          </button>

        </div>

        {/* ── Footer ── */}
        <div className="login-footer">
          <span className="status-dot" style={{ marginRight: 6 }} />
          © 2026 <strong>Saami Tradestar Logistics Ltd</strong> &nbsp;·&nbsp; ILMS v2.4.1
        </div>

      </div>
    </div>
  );
}
